import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Mail, LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Logo } from "@/components/brand";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Connexion réussie");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Échec de la connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-dh-black dh-grain px-5">
      <div className="pointer-events-none absolute -top-24 right-0 h-72 w-72 rounded-full bg-dh-red opacity-20 blur-[100px]" />
      <div className="relative z-10 w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center">
          <Logo size={64} />
          <h1 className="mt-4 font-display text-3xl font-extrabold uppercase tracking-tight text-white">Back-office</h1>
          <p className="text-sm text-white/40">Douzième Homme — Le Jeu</p>
        </div>
        <form onSubmit={submit} className="space-y-4 rounded-3xl border border-dh-borderDark bg-dh-cardDark p-6">
          <div className="flex items-center gap-3 rounded-2xl border border-dh-borderDark bg-dh-black/40 px-4 focus-within:border-dh-red">
            <Mail className="h-5 w-5 text-white/40" />
            <input
              data-testid="admin-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              required
              className="flex-1 bg-transparent py-4 text-white outline-none placeholder:text-white/30"
            />
          </div>
          <div className="flex items-center gap-3 rounded-2xl border border-dh-borderDark bg-dh-black/40 px-4 focus-within:border-dh-red">
            <Lock className="h-5 w-5 text-white/40" />
            <input
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Mot de passe"
              required
              className="flex-1 bg-transparent py-4 text-white outline-none placeholder:text-white/30"
            />
          </div>
          <button
            data-testid="admin-login-btn"
            type="submit"
            disabled={loading}
            className="flex h-14 w-full items-center justify-center gap-2 rounded-2xl bg-dh-red font-display text-base font-extrabold uppercase tracking-wider text-white disabled:opacity-50 active:scale-[0.98]"
          >
            {loading ? "Connexion..." : <><LogIn className="h-5 w-5" /> Se connecter</>}
          </button>
        </form>
      </div>
    </div>
  );
}
